.cmm-languages-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: var(--wb-spacing-xs, 1rem);
}

.cmm-languages-list__item--actived::after {
  content: ' ';
  display: block;
  width: 100%;
  height: 2px;
  border-bottom: 2px solid var(--wb-button-primary-border-main-color-hover);
}

.cmm-languages-list__item--non-actived::after {
  content: ' ';
  display: block;
  width: 100%;
  height: 2px;
  border-bottom: 2px solid rgb(0 0 0 / 0%);
}
